import MarketingShell from "@/components/marketing/MarketingShell";

export default function Terms() {
    return (
        <MarketingShell
            title="Terms of Service — Furmais"
            description="Furmais terms of service — acceptable use, output ownership, and billing terms."
        >
            <article className="relative z-10 px-6 sm:px-10 pt-12 pb-24 max-w-3xl mx-auto" data-testid="terms-page">
                <div className="label-micro mb-3 text-[#FF4400]">Legal</div>
                <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-6">Terms of Service</h1>
                <p className="text-zinc-400 mb-8">Last updated: May 2026</p>

                <section className="text-zinc-300 space-y-5 leading-relaxed">
                    <h2 className="font-display text-2xl text-white">1. Acceptable use</h2>
                    <p>
                        Furmais is provided for lawful creative production work. You agree not to
                        use it to generate illegal content, infringe third-party IP, or attempt
                        to reverse-engineer the platform.
                    </p>

                    <h2 className="font-display text-2xl text-white pt-4">2. Output ownership</h2>
                    <p>
                        You retain full ownership of your project briefs, uploaded assets, and
                        the AI-generated outputs you approve in the pipeline. Furmais retains
                        rights only to anonymous operational metrics needed to keep the system
                        reliable.
                    </p>

                    <h2 className="font-display text-2xl text-white pt-4">3. AI limitations</h2>
                    <p>
                        AI outputs may contain errors. You are responsible for review and
                        approval before publishing or sharing with clients. The pipeline flags
                        assumptions explicitly — please verify any field marked as inferred.
                    </p>

                    <h2 className="font-display text-2xl text-white pt-4">4. Billing &amp; quota</h2>
                    <p>
                        Plans are administered manually during the early access phase. Usage
                        is metered per client and per campaign and visible in your dashboard.
                    </p>

                    <h2 className="font-display text-2xl text-white pt-4">5. Termination</h2>
                    <p>
                        You may close your account anytime by emailing
                        <a href="mailto:support@furmais.com" className="text-[#FF4400] hover:underline mx-1">support@furmais.com</a>.
                        We may suspend accounts that abuse the service.
                    </p>

                    <h2 className="font-display text-2xl text-white pt-4">6. Contact</h2>
                    <p>
                        Questions: <a href="mailto:support@furmais.com" className="text-[#FF4400] hover:underline">support@furmais.com</a>.
                    </p>
                </section>
            </article>
        </MarketingShell>
    );
}
